import React, { useEffect, useState } from 'react';
import SpotDetail from '../components/spot/SpotDetail';
import { httpGetWaveForecastByStationId, httpGetWeatherNowByLocationId } from "../hooks/forecast/api";
import { httpGetSpotById } from "../hooks/spot/api";
import { useParams } from 'react-router-dom';


export default function SpotDetailPage() {

  const { spotId } = useParams();

  const [spot, setSpot] = useState([]);
  const [waveForecast, setWaveForecast] = useState([]);
  const [waveRealTimeBuoyId, setWaveRealTimeBuoyId] = useState([]);
  const [waveStationForecast, setWaveStationForecast] = useState("");
  const [weatherNow, setWeatherNow] = useState([]);
  const locationId = '1'      // TO-DO: remove hardcode and add logic to identify location based on favorite spot
  
  const loadData = () => {

    // today's weather
    httpGetWeatherNowByLocationId(locationId).then( 
      (result) => { 
        setWeatherNow(result);
        
    })
   
    // get current waves condition (real time)
    httpGetSpotById(spotId).then( 
        (result) => { 
        setSpot(result)

        // get station id for the spot
        const stationId = result.noaa_station_id_forecast
        const cdip_stationId = result.cdip_spotStation
        setWaveRealTimeBuoyId(cdip_stationId)
        setWaveStationForecast(stationId)

        // get waves forecast using station id
        httpGetWaveForecastByStationId(stationId).then( 
          (result) => { 
            setWaveForecast(result);
        })
    })
}

useEffect(() => {
    loadData();
}, []);

  const landingPage = () => {
        return <SpotDetail spot={spot} 
              waveStationForecast={waveStationForecast} 
              waveForecast={waveForecast} 
              waveRealTimeBuoyId={waveRealTimeBuoyId}
              weather={weatherNow}
              />
  }

   return (
    <div>
      { landingPage() } 
    </div>
  ) 

}
